import { Link, useLocation } from "react-router-dom";
import { logout } from "../../api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import navItems from "../../Json/header.json";
import { useEffect, useRef, useState } from "react";

const LandingHeader = () => {
  const navigate = useNavigate();
  const [menuOpen, setIsMenuOpen] = useState(false);
  const { pathname, hash, state } = useLocation();
  const mobref = useRef();
  let url = pathname.split("/");

  const token = localStorage.getItem("token");

  const handleLogin = (url) => {
    navigate(`/login/${url}`);
  };
  const handleclick = () => {
    setIsMenuOpen(!menuOpen);
  };

  const handleUrlClick = (e, item) => {
    if (item.href.startsWith("#")) {
      e.preventDefault(); // Prevent default React Router
      const targetId = item.href.replace("#", "");
      console.log(targetId, "targetId");

      if (pathname !== "/home") {
        navigate("/home", { state: { scrollTo: targetId } });
      } else {
        const element = document.getElementById(targetId);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  useEffect(() => {
    if (state?.scrollTo) {
      const targetId = state.scrollTo;
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 0);

      window.history.replaceState({}, document.title);
    }
  }, [state]);

  useEffect(() => {
    const closeMenus = (e) => {
      // Check if the click is outside the ref element and the toggle button
      if (
        mobref.current &&
        !mobref.current.contains(e.target) &&
        !e.target.closest(".menubarbtn")
      ) {
        setIsMenuOpen((prev) => !prev);
      }
    };
    document.body.addEventListener("click", closeMenus);
    return () => document.body.removeEventListener("click", closeMenus);
  }, [mobref, menuOpen]);

  return (
    <div className="w-full bg-white flex justify-center sticky top-0 shadow-services bg-white z-[100] ">
      <div className="2xl:container mx-auto w-full md:px-14 lg:px-20 px-6 py-6">
        <div className="flex justify-between items-center ">
          <div className="  w-fit flex flex-col ">
            <Link to={"/home"}>
              <img
                className="h-[35px] sm:h-[40px]"
                src={process.env.PUBLIC_URL + "/images/login/headerlogo.svg"}
                alt="xpress_logo"
              />
            </Link>
            <p className=" text-[8px]  flex gap-1 text-black  justify-end">
              Powered by
              <Link target="_blank" to={"https://www.transforma.in/"}>
                <img
                  className="h-[9px] sm:h-[10px]"
                  src={process.env.PUBLIC_URL + "/images/logos/Transforma.svg"}
                  alt="xpress_logo"
                />
              </Link>
            </p>
          </div>
          {/* MARK:Desktop view */}
          <div className="hidden min-[970px]:flex gap-5 lg:pl-[5%]">
            {navItems.header.map((item, index) => (
              <Link
                key={index}
                to={item.href}
                onClick={(e) => handleUrlClick(e, item)}
                target={item.target ? "_" : undefined}
                className={`text-16 font-medium ${
                  item.hover === url[1]
                    ? "text-orange"
                    : "text-secondaryblack hover:text-orange "
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>
          <div className=" items-center hidden min-[970px]:flex justify-end gap-x-5 ">
            {!token && (
              <>
                <button
                  onClick={() => handleLogin("signin")}
                  className="h-9 py-[23px] px-[35px] flex items-center border-orange border text-16 hover:bg-btnhover hover:text-white  rounded-[36px] bg-transparent text-orange font-medium"
                >
                  Login
                </button>
                <button
                  onClick={() => handleLogin("signup")}
                  className="h-9 py-[23px] px-[35px] flex  hover:bg-btnhover  border items-center text-16 rounded-[36px] bg-orange text-white font-medium"
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
          {/* MARK:Mobile view */}
          <div className="flex min-[970px]:hidden sm:-mr-[30px]  menubarbtn">
            <button
              className="relative flex flex-col items-center justify-center w-12 h-12 rounded focus:outline-none"
              onClick={handleclick}
            >
              <span
                className={`block w-6 h-0.3 border-black border-[1px] opacity-75 border-black transform transition duration-300 ease-in-out ${
                  menuOpen ? "rotate-45 translate-y-1" : "-translate-y-1.5"
                }`}
              ></span>
              <span
                className={`block w-6 h-0.3 border-black border-[1px] transform transition duration-300 ease-in-out ${
                  menuOpen ? "opacity-0" : "opacity-75"
                }`}
              ></span>
              <span
                className={`block w-6 h-0.3 border-black border-[1px] opacity-75 transform transition duration-300 ease-in-out ${
                  menuOpen ? "-rotate-45 -translate-y-1.2" : "translate-y-1.5"
                }`}
              ></span>
            </button>
          </div>
          {menuOpen ? (
            <div
              ref={mobref}
              className="absolute min-[1100px]:hidden bg-white shadow-products top-[95px] left-0 w-full py-6 md:px-20 z-500 h-fit max-h-[70vh] overflow-auto"
            >
              <div className="flex flex-col w-full space-y-2  ">
                {navItems.header.map((item, id) => (
                  <div
                    className={`py-3   ${!item.submenu ? "flex" : ""}`}
                    key={id}
                  >
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setIsMenuOpen(!menuOpen)}
                      className={`text-16 font-medium ${
                        item.hover === url[1]
                          ? "text-orange"
                          : "text-secondaryblack hover:text-orange "
                      } ${!item.submenu ? "w-full" : ""}`}
                    >
                      {item.name}
                    </Link>
                  </div>
                ))}
                <div className=" items-center flex justify-center gap-x-5 pt-3">
                  <button
                    onClick={() => handleLogin("signin")}
                    className="h-9 py-4 px-8 flex items-center border-orange border text-16 hover:bg-btnhover hover:text-white rounded-[36px] bg-transparent text-orange font-medium"
                  >
                    Login
                  </button>
                  <button
                    onClick={() => handleLogin("signup")}
                    className="h-9 py-4 px-8 flex items-center hover:bg-btnhover hover:text-white text-16 rounded-[36px] bg-F37021 text-white font-medium"
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
export default LandingHeader;
